import React from 'react';
import { render } from 'react-dom';

import withDataFetch from '../api-components/hoc/withDataFetch';
import RelatedList from '../display/components/RelatedList';
import formatQueryParams from '../format-query-params';
import formatArticle from '../format-article';
import select from '../utils/select';
import ajaxer from '../ajax';
import { __TEST__ } from '../constants';
import {
  SELECTOR,
  RECENT_EVENTS_PARAMS,
  RECENT_EVENTS_FIELDS,
  RECENT_EVENTS_API_URL,
} from './constants';

/*
  This module is exposed in the main bundle.
  Django template: templates/shadow_layouts/js_components/recent_events.html
*/

function buildFetcher() {
  const url = `${RECENT_EVENTS_API_URL}?${formatQueryParams(
    RECENT_EVENTS_PARAMS,
    RECENT_EVENTS_FIELDS
  )}`;

  return async () => {
    const {
      data: { results },
    } = await ajaxer.get(url);

    return results.map(result => formatArticle(result));
  };
}

export default function buildRecentEvents() {
  const targetEl = select(`#${SELECTOR}`);

  if (targetEl != null) {
    const heading = { text: 'recent events' };
    const ga = { action: 'recent events', label: 'events landing' };
    const ComponentWithFetch = withDataFetch(RelatedList, {
      fetcher: buildFetcher(),
      scroll: { element: targetEl },
    });
    const ToRender = (
      <ComponentWithFetch heading={heading} ga={ga} useUpdatedDate />
    );

    if (!__TEST__) render(ToRender, targetEl);
    return ToRender;
  }

  return null;
}
